import { TabDatosCalificacion } from "./TabDatosCalificacion";
import { TabMonitoreo } from "./TabMonitoreo";

export const tabs = [
    {
        id: 1,
        name: 'Datos de Calificación',
        component: <TabDatosCalificacion />,
    },
    {
        id: 2,
        name: 'Monitoreo',
        component: <TabMonitoreo />,
    }
];